import React, { Component } from 'react';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { actionCreators } from '../store/actions/dataActions';
import { Link, withRouter } from 'react-router-dom';
import { Spinner, Alert } from 'react-bootstrap';

// Import React Table
import ReactTable from "react-table";
import "react-table/react-table.css";



class RecipientsList extends Component {
    

    componentDidMount() {
        // This method is called when the component is first added to the document
        this.ensureDataFetched();

    }

    componentDidUpdate() {
        // This method is called when the route parameters change
        //this.ensureDataFetched();
    }

    ensureDataFetched() {
       
        // this.props.requestWeatherForecasts(startDateIndex);
        if (!this.props.currentRecipientImper) {
          
            this.props.getRecipient();
        }  
          
    }
   
    render() {       
        return (
            <span>{this.props.currentRecipientImper ? "("+this.props.currentRecipientImper.catalogue+")" : ""}</span>
          
        );
    }
}


//function mapStateToProp(state) {
//    return {
//        auth: state.weatherForecasts,
//        data: state.data
//    };
//}

//export default connect(mapStateToProp, { getData })(withRouter(FetchData))(FetchData);

export default withRouter( connect(
    state => state.data,
    dispatch => bindActionCreators(actionCreators, dispatch)
)(RecipientsList));



// WEBPACK FOOTER //
// ./src/components/RecipientNav.js